import React from 'react';
import { object, string, ref } from 'yup';
import omit from 'lodash/omit';

import FormResource from './FormResource.jsx';
import FormGroup from '~/commons/components/FormGroup.jsx';
import FormCheckGroup from '~/commons/components/FormCheckGroup.jsx';

import FieldsCompPicker from './competition/FieldsCompPicker.jsx';

import { env } from '~/commons/config';

const defaults = {
  active: true,
  username: '',
  password: '',
  name: { full: { en: '', zhhk: '' } },
};

const FormAdmin = ({
  school,
  admin,
}) => {
  const isSchoolAdmin = env.user.roles.includes('schoolAdmin');

  return (
    <FormResource
      {...{
        defaults: {
          ...defaults,
          ...(
            school
              ? {
                school: school._id,
                roles: ['schoolAdmin'],
                competition: '',
              }
              : { roles: ['admin'] }
          ),
          ...(isSchoolAdmin ? { confirmPassword: '' } : ''),
        },
        schema: object({
          username: string().required(),
          ...(!admin ? {
            password: string().required(),
          } : {}),
          ...(isSchoolAdmin ? {
            confirmPassword: string()
              .when(
                'password',
                {
                  is: (p) => p,
                  then: (s) => s.required().oneOf(
                    [ref('password')],
                    'Password does not match',
                  ),
                },
              ),
          } : {}),
        }),
        stored: admin,
        api: 'api/core/users/admins',
        onSubmit: (v) => omit(v, !v.password ? 'password' : null),
      }}
    >
      {env.user.roles.includes('admin') && (
        <div className="form-group">
          <label>Active</label>
          <FormCheckGroup
            name="active"
            type="checkbox"
            label=""
            asSwitch
          />
        </div>
      )}
      {school && (
        <FieldsCompPicker />
      )}
      <FormGroup
        name="username"
        disabled={isSchoolAdmin}
      />
      <div className="form-row">
        <div className="col">
          <FormGroup name="name.full.zhhk" label="Name (Chinese)" />
        </div>
        <div className="col">
          <FormGroup name="name.full.en" label="Name (English)" />
        </div>
      </div>
      <div className="form-row">
        <div className="col">
          <FormGroup
            name="password"
            type="password"
            placeholder={
              admin ? 'Leave this blank to keep the stored password' : ''
            }
          />
        </div>
        {isSchoolAdmin && (
          <div className="col">
            <FormGroup
              name="confirmPassword"
              type="password"
              placeholder={
                admin ? 'Leave this blank to keep the stored password' : ''
              }
            />
          </div>
        )}
      </div>
    </FormResource>
  );
};

export default FormAdmin;
